import {
  selectFiltersQuery,
  selectIsCompareMode,
  selectLifecycleFiltersQuery,
} from 'util/selector/querySelector';
import { selectReportOrCurrentProjectId } from 'util/selector/reportSelector';

import { selectIsLifecycleProjectKind } from 'reduxStore/project/selectors';
import { simpleProjectApi } from 'container/simpleProjectApi';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { SimpleProject } from 'model/SimpleProject';
import { abortAndRefreshSignalByKey } from 'shared/utils/api/abortAndRefreshSignalByKey';

import { STORE_NAME } from './initialState';

const ABORT_CONTROLLER_KEY = `${STORE_NAME}/abortController`;

export const fetchSimpleProject = createAsyncThunk<void>(
  `${STORE_NAME}/fetchSimpleProject`,
  async (_, { getState, dispatch }) => {
    const isCompareMode = selectIsCompareMode(getState());

    if (isCompareMode) {
      await dispatch(fetchSimpleProjectCompare());
    } else {
      await dispatch(fetchSimpleProjectCombine());
    }
  },
  { serializeError }
);

export const fetchSimpleProjectCombine = createAsyncThunk<SimpleProject.Combine | void>(
  `${STORE_NAME}/fetchSimpleProjectCombine`,
  (_, { getState }) => {
    const signal = abortAndRefreshSignalByKey(ABORT_CONTROLLER_KEY);
    const projectId = selectReportOrCurrentProjectId(getState());
    const isLifecycleKind = selectIsLifecycleProjectKind(getState());
    const query = isLifecycleKind
      ? selectLifecycleFiltersQuery(getState())
      : selectFiltersQuery(getState());

    return simpleProjectApi.combine({ projectId, query }, { signal });
  },
  { serializeError }
);

export const fetchSimpleProjectCompare = createAsyncThunk<SimpleProject.Compare | void>(
  `${STORE_NAME}/fetchSimpleProjectCompare`,
  (_, { getState }) => {
    const signal = abortAndRefreshSignalByKey(ABORT_CONTROLLER_KEY);
    const projectId = selectReportOrCurrentProjectId(getState());
    const isLifecycleKind = selectIsLifecycleProjectKind(getState());
    const query = isLifecycleKind
      ? selectLifecycleFiltersQuery(getState())
      : selectFiltersQuery(getState());

    return simpleProjectApi.compare({ projectId, query }, { signal });
  },
  { serializeError }
);
